import React from 'react';
import { Layout, Result } from 'antd';
import { useTranslation } from 'react-i18next';

export const InternalErrorPage = () => {
  const { t } = useTranslation();

  return (
    <Layout className="min-h-full flex items-center justify-center">
      <Result status="500" title="500" subTitle={t('error.internalError')} />
    </Layout>
  );
};
